"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceBucketKeysWithUrlsInArray;

var _replaceBucketKeysWithUrls = _interopRequireDefault(require("./replaceBucketKeysWithUrls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Takes an array of data objects and swaps out any defined key/bucketKey values with pre-signed urls
 * in each item. Supports nested keys/subkeys.
 *
 * eg.
 *
 * [
 *  { foo: '/foo/foobar.jpg' },
 *  { foo: '/bar/barfoo.jpg' }
 * ], ['foo']
 *
 *    =>
 *
 * [
 *  { foo: 'aws.com/.../foo/foobar.jpg' },
 *  { foo: 'aws.com/.../bar/barfoo.jpg' }
 * ]
 *
 * @param {*} apiClient
 * @param {Array<Object>} dataArray
 * @param {Array<SubstitutedKey>} substitutedKeys
 * @param {string} organisationId
 *
 * @return {Promise<*>}
 */
async function replaceBucketKeysWithUrlsInArray({
  apiClient,
  dataArray,
  substitutedKeys,
  organisationId,
  ignorePattern
}) {
  return Promise.all(dataArray.map(dataItem => (0, _replaceBucketKeysWithUrls.default)({
    apiClient,
    data: dataItem,
    substitutedKeys,
    organisationId,
    ignorePattern
  })));
}